export default {
	EventInfo: 1,
	EventDetails: 2,
	LaneConditions: 3,
	Setup: 4,
	Participants: 5,
	EventTemplate: 6
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Constants/EventWizardPage.js